import React from "react";
import styles from "./Marquee.module.css";

function Marquee() {
  const items = [
    "Claude Code", "OpenAI Codex", "OpenClaw", "Agent Orchestration",
    "React", "Next.js", "Node.js", "TypeScript", "Python",
    "MongoDB", "LLM APIs", "MCP Servers", "Prompt Engineering",
    "React Native", "Vercel", "Git",
  ];

  const renderItems = [...items, ...items].map((item, i) => (
    <span key={i} className={styles.itemWrap}>
      <span className={styles.itemText}>{item}</span>
      <span className={styles.sep}>/</span>
    </span>
  ));

  return (
    <div className={styles.marquee} style={{ opacity: 0, animation: "fadeIn 0.6s ease-out 0.1s forwards" }}>
      <span className={styles.label}>tech stack</span>
      <div className={styles.trackWrap}>
        <div className={styles.fadeLeft}></div>
        <div className={styles.fadeRight}></div>
        <div className={styles.track}>
          <div className={styles.scroll}>
            {renderItems}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Marquee;
